var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.0251 22.69H68.4879V14.0115C68.4879 9.8792 65.126 6.51758 60.9938 6.51758H39.0046C34.8724 6.51758 31.5106 9.8792 31.5106 14.0115V22.69H9.9733C4.48683 22.69 0.023107 27.1537 0.023107 32.6402C0.023107 37.6238 -0.487276 42.0994 3.28932 47.1326C5.42607 49.9803 8.36241 52.0117 11.7808 53.0069L44.9753 62.6716C48.2561 63.6285 51.7419 63.6285 55.0227 62.6716L88.2172 53.0069C91.6356 52.0115 94.5719 49.9803 96.7087 47.1326C100.502 42.0768 99.9749 37.5551 99.9749 32.6402C99.9751 27.1537 95.5116 22.69 90.0251 22.69ZM37.8581 14.0115C37.8585 13.7075 37.9794 13.4161 38.1943 13.2012C38.4093 12.9863 38.7007 12.8654 39.0046 12.8651H60.9938C61.2977 12.8654 61.5891 12.9863 61.8041 13.2012C62.019 13.4161 62.1399 13.7075 62.1403 14.0115V22.69H37.8581V14.0115Z",
    fill: "url(#paint0_linear_4_33328)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9921 59.1014C54.1877 69.5261 54.6513 69.7369 49.9993 69.7369C45.3807 69.7369 46.4764 69.7199 10.0068 59.1016C6.16152 57.9818 2.75606 55.9181 0.0234375 53.073V83.5325C0.0234375 89.019 4.48696 93.4825 9.97363 93.4825H90.0252C95.5117 93.4825 99.9754 89.019 99.9754 83.5325V53.073C97.2426 55.9179 93.8371 57.9818 89.9921 59.1014Z",
    fill: "url(#paint1_linear_4_33328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_33328",
    x1: 2.0068e-7,
    y1: 9.46532,
    x2: 71.6804,
    y2: 99.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_33328",
    x1: 0.0234377,
    y1: 55.1675,
    x2: 44.8762,
    y2: 134.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessMarketing);
export default __webpack_public_path__ + "static/media/Business-Marketing.454ccd4cd5a783484ae5e1b7a2849b5e.svg";
export { ForwardRef as ReactComponent };